<template>
    <div class="modalCreateCalendarContainer">
        <transition name="slide-left">
            <CalendarForm v-if="calendarForm" :CalendarCreateObjectByParent="calendarCreateObject" @closeCalendarCreateModal="closeCalendarCreateModal" @switchFormTwo="switchFormTwo" :IsEdit="isEdit"></CalendarForm>
        </transition>
        <transition name="slide-right">
            <ProgramForm v-if="programForm" :ProgramCreateDataByParent="programData" :ProgramCreateDataObjectByParent="programDataObject" @switchFormOne="switchFormOne" @closeCalendarCreateModal="closeCalendarCreateModal" @addCalendarPrograms="addCalendarPrograms" :IsEdit="isEdit" @editCalendarPrograms="editCalendarPrograms"></ProgramForm>
        </transition>
    </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
//Importa el componente que contiene el formulario para la creación
import CalendarForm from './FormularioCalendario.vue'
//Importa el componente que contiene el formulario para la creación
import ProgramForm from '@/components/CalendarioAcademico/FormularioPrograma.vue'

export default{
    components: {
        CalendarForm,
        ProgramForm
    },
    props: {
        IsEdit: Boolean,
        IdCalendarForEdit: Number,
    },
    data(){
        return{
            isCalendarForEdit: this.IdCalendarForEdit,
            isEdit: this.IsEdit,
            calendarForm: true,
            programForm: false,
            calendarCreateObject : {
                calendarId: '',
                periodoBanner: '',
                periodo: '',
                periodoAnterior: '',
                periodoSiguiente: '',
                inicioPago: '',
                inicioPeriodo: '',
                corte: '',
                finPago: '',
                finPeriodo: '',
                inicioSiguientePeriodo: '',
                estado: '',
                entrada: '',
                programas: [],
            }, 
            programData: [],
            programDataObject: [],
        }
    },
    methods: {
        //Carga los datos para la edición
        loadData(){
            if(this.isEdit){
                IberoHelpers.GetCalendarForId(this.$store, this.isCalendarForEdit)
                .then(response => {
                    const data = response.data[0];
                    this.calendarCreateObject.periodoBanner = data.periodoBanner;
                    this.calendarCreateObject.periodo = data.periodo;
                    this.calendarCreateObject.periodoAnterior = data.periodoAnterior;
                    this.calendarCreateObject.periodoSiguiente = data.periodoSiguiente;
                    // Formatear las fechas manualmente
                    this.calendarCreateObject.inicioPago = this.formatDate(data.fechaInicioPago);
                    this.calendarCreateObject.inicioPeriodo = this.formatDate(data.fechaInicioPeriodo);
                    this.calendarCreateObject.corte = this.formatDate(data.fechaCorte);
                    this.calendarCreateObject.finPago = this.formatDate(data.fechaFinPago);
                    this.calendarCreateObject.finPeriodo = this.formatDate(data.fechaFinPeriodo);
                    this.calendarCreateObject.inicioSiguientePeriodo = this.formatDate(data.fechaInicioSiguientePeriodo);
                    this.calendarCreateObject.estado = data.staActive ? '1' : '0';
                    this.calendarCreateObject.entrada = data.entrada;
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });

                IberoHelpers.GetProgramForId(this.$store, this.isCalendarForEdit)
                .then(response => {
                    this.programData = response.data.map(object => object.programa);
                    this.programDataObject = response.data.map(({programa, cod_Programa}) => ({
                        programa: programa,
                        codPrograma: cod_Programa,
                    }));
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });
            } 
        },
        formatDate(dateString) {
            // Formatear la fecha al formato "yyyy-MM-dd"
            const date = new Date(dateString);
            const year = date.getFullYear();
            let month = (date.getMonth() + 1).toString();
            let day = date.getDate().toString();

            // Agregar un 0 al principio si el número es de un solo dígito
            if (month.length === 1) {
                month = '0' + month;
            }
            if (day.length === 1) {
                day = '0' + day;
            }

            return `${year}-${month}-${day}`;
        },
        //Método para cerrar el modal
        closeCalendarCreateModal(){
            this.$emit('closeCalendarCreateModal');
        },
        //Método para cambiar al formulario de programas
        switchFormTwo(data){
            this.calendarForm = false;
            this.programForm = true;
            this.calendarCreateObject = data;
        },
        //Método para cambiar al formulario de calendario
        switchFormOne(dataArray, dataObject ){
            this.programForm = false;
            this.calendarForm = true;
            this.programData = dataArray;
            this.programDataObject = dataObject;
        },
        //Método para insertar la data de los formularios
        addCalendarPrograms(){
            this.calendarCreateObject.periodo += ' ' + this.calendarCreateObject.entrada;
            this.calendarCreateObject.programas = this.programDataObject;
            IberoHelpers.AddProgramsForCalendar(this.$store, this.calendarCreateObject);
            this.$emit('insertDataPeriods');
        },
        //Método para editar la data de un registro
        editCalendarPrograms(){
            this.calendarCreateObject.periodo += ' ' + this.calendarCreateObject.entrada;
            this.calendarCreateObject.programas = this.programDataObject;
            this.calendarCreateObject.calendarId = this.isCalendarForEdit;
            IberoHelpers.EditProgramsForCalendar(this.$store, this.calendarCreateObject);
            this.$emit('editDataPeriods');
        }
    },
    mounted () {
        //Llama el método que trae los datos para la edición en caso de que se abra el modal para esto
        this.loadData()
    },
    beforeDestroy(){
        this.calendarCreateObject = {
            calendarId: '',
            periodoBanner: '',
            periodo: '',
            periodoAnterior: '',
            periodoSiguiente: '',
            inicioPago: '',
            inicioPeriodo: '',
            corte: '',
            finPago: '',
            finPeriodo: '',
            inicioSiguientePeriodo: '',
            estado: '',
            entrada: '',
            programas: [],
        };
    }
}  
</script>
<style scoped>

    .modalCreateCalendarContainer{
        display: flex;
        position: relative;
    }
    .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter-active, .slide-right-leave-active {
        transition: all 0.5s;
    }

    .slide-left-enter, .slide-left-leave-to, .slide-right-enter, .slide-right-leave-to {
        transform: translateX(0);
        opacity: 1;
        position: absolute;
    }

    .slide-left-enter, .slide-left-leave-to {
        transform: translateX(-100%);
        opacity: 0;
    }

    .slide-right-enter, .slide-right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }
</style>